<template lang="pug">
  .roast-info
    .roast-info__label.preheader {{ getRoastName }} Roast
    .roast-info__indicator(
      :class="getRoastClass"
    )
</template>

<script>
  import roastLevels from 'scripts/helpers/roastLevels.js';

  export default {
    name: "ProductRoast",
    props: {
      level: {
        type: String,
        default: 'medium',
      },
    },
    computed: {
      getRoastClass() {
        return roastLevels[this.level].class;
      },
      getRoastName() {
        return roastLevels[this.level].label;
      }
    },
  };
</script>

<style lang="scss" scoped>
  .roast-info {
    display: flex;
    align-items: center;
  }

  .roast-info__label {
    margin-right: 8px;
    font-size: rem(14);
    font-family: $font-acumin-pro;
    font-weight: 500;
    color: $color-indigo;
    text-transform: uppercase;

    @include tablet-up {
      font-size: rem(16);
    }
  }

  .roast-info__indicator {
    position: relative;
    margin-top: 2px;
    border: 1px solid $color-indigo;
    height: 12px;
    width: 35px;

    &::before {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      background-color: $color-pink;
    }

    &.roast-light {
      &::before {
        right: 80%;
      }
    }

    &.roast-medium {
      &::before {
        right: 50%;
      }
    }

    &.roast-medium-dark {
      &::before {
        right: 20%;
      }
    }

    &.roast-dark {
      &::before {
        right: 0px;
      }
    }
  }
</style>
